import { useEffect, useState } from "react";
import { RESET_SEARCH } from "../Redux/Actions/types";

export const useDebouncedSearchDispatch = ({
  value,
  delay = 500,
  minLen = 3,
  dispatch,
  fetchAction,
  search_type,
  context,
}) => {
  const [debounced, setDebounced] = useState(value || "");

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value || ""), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  useEffect(() => {
    const q = (debounced || "").trim();

    if (q.length >= minLen) {
      dispatch(fetchAction({ search_type, search_char: q, context }));
    } else {
      dispatch({ type: RESET_SEARCH, payload: { context } });
    }
  }, [debounced, minLen, dispatch, fetchAction, search_type, context]);

  return debounced;
};